



function hideElements() {
  $('body').removeClass('show-prices');

  const elementsToHide = [
    "._pricestable",
    ".product__price",
    ".grid-product__price",
    ".installement__price",
    ".product-single__form",
    ".cart-link",
    ".grid-product__tag",
    ".product__discount-percentage",
    ".discount-badge-wrapper",
    ".collection-discount-badge-wrapper",
    ".primeBadges .prime-d-block",
    ".mobilephone",
    ".rbr-container-element-true",
    "#rbr-container-element-false",
    ".rbr-sbap_body",
    ".bundle-contents-wrapper",
    ".price-overlay",
    ".hide-international"
  ];

  elementsToHide.forEach(selector => {
    $(selector).hide();
  });
}

function showElements() {
  $('body').addClass('show-prices');

  // hideElements ile gizlenen tum elementlerin inline style'ini temizle:
  const elementsToRestore = [
    "._pricestable",
    ".product__price",
    ".grid-product__price",
    ".installement__price",
    ".product-single__form",
    ".cart-link",
    ".grid-product__tag",
    ".product__discount-percentage",
    ".discount-badge-wrapper",
    ".collection-discount-badge-wrapper",
    ".primeBadges .prime-d-block",
    ".mobilephone",
    ".rbr-container-element-true",
    "#rbr-container-element-false",
    ".rbr-sbap_body",
    ".payment-icons",
    ".core__room",
    ".bundle-contents-wrapper",
    ".price-overlay",
    ".hide-international"
  ];

  elementsToRestore.forEach(selector => {
    $(selector).css('display', '');
  });
}

function get_country_code() {
  return new Promise((resolve, reject) => {
    $.ajax('/cdn-cgi/trace', {
      success: function(response) {
        const lines = response.split('\n');
        for (const line of lines) {
          const [key, value] = line.split('=');
          if (key === 'loc' && value !== 'XX') {
            return resolve(value);
          }
        }
        reject('Country code not found');
      },
      error: function(err) {
        reject(err);
      }
    });
  });
}

var _countryCode = null;
var _blockedCountries = "AL, BA, BG, FR, ME, KZ, XK, MK, MT, PL, RO, RS, UA, SK, SI, GR, CH".split(',').map(function(c) { return c.trim(); }).filter(Boolean);
var _mode = "contents";

function isCountryAllowed(country) {
  if (_mode === "none") {
    // Show Only Turkey - sadece TR gorebilir
    return country === "TR";
  } else {
    // Show All Country - blocked listesindekiler goremez
    return _blockedCountries.indexOf(country) === -1;
  }
}

function applyCountryRules() {
  if (!_countryCode) return;
  if (_mode === "none") {
    if (_countryCode === "TR") {
      showElements();
    } else {
      hideElements();
    }
  } else if (_blockedCountries.length > 0 && _blockedCountries.indexOf(_countryCode) !== -1) {
    hideElements();
  }
}

function setupMutationObserver() {
  var debounceTimer = null;
  var isProcessing = false;
  const observer = new MutationObserver(() => {
    if (debounceTimer || isProcessing) return;
    debounceTimer = setTimeout(() => {
      debounceTimer = null;
      isProcessing = true;
      observer.disconnect();
      applyCountryRules();
      setTimeout(() => {
        isProcessing = false;
        observer.observe(document.body, { childList: true, subtree: true });
      }, 500);
    }, 300);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

$(document).ready(() => {
  if (_mode === "none") {
    // Show Only Turkey: gizle, sonra TR ise goster
    hideElements();
    get_country_code().then(country => {
      _countryCode = country;
      if (country === "TR") {
        showElements();
      }
    }).catch(err => {
      console.error('Country detection error:', err);
    });
    setupMutationObserver();
  } else if (_blockedCountries.length > 0) {
    // Show All Country + blocked list var: blocked ulkeleri gizle, digerleri goster
    get_country_code().then(country => {
      _countryCode = country;
      if (_blockedCountries.indexOf(country) !== -1) {
        hideElements();
      } else {
        showElements();
      }
    }).catch(err => {
      console.error('Country detection error:', err);
    });
    setupMutationObserver();
  }
  // Show All Country + blocked list bos: hicbir sey yapma
});

